import React from 'react';
import Chart from 'react-apexcharts';
import MuiTypography from '@mui/material/Typography';
import { Box } from '@mui/material';
import { traducciones } from '../../views/pages/operator/ProductionRecordsPage';
import { useTheme } from '@mui/material/styles';

const DowntimeStackedChart = ({ chartData, height = 350, showLabel = true, isDarkMode = false, showToolbar = true }) => {
    const theme = useTheme();

    const fontFamily = `Inter, sans-serif`;
    const LINE_COLOR = theme.palette.secondary.dark;
    const AXIS_COLOR = isDarkMode ? '#FFFFFF' : theme.palette.grey[700];
    const GREEN = isDarkMode ? '#FFFFFF' : theme.palette.primary.main;
    if (!chartData) return null;

    const options = {
        chart: {
            type: 'bar',
            stacked: true,
            height: height,
            locales: [traducciones],
            defaultLocale: 'es',
            animations: {
                enabled: false
            },
            fontFamily,
            toolbar: {
                show: showToolbar,
                export: {
                    csv: {
                        filename: `Gráfico de utilización (minutos/hora).`,
                        headerCategory: 'Horas'
                    },
                    svg: { filename: `Gráfico de utilización (minutos/hora).` },
                    png: { filename: `Gráfico de utilización (minutos/hora).` }
                }
            }
        },
        noData: {
            text: 'No hay datos disponibles',
            align: 'center',
            verticalAlign: 'middle',
            style: {
                color: AXIS_COLOR,
                fontSize: '16px',
                fontFamily: fontFamily
            }
        },
        plotOptions: {
            bar: {
                columnWidth: '80%',
                borderRadius: 0
            }
        },
        stroke: {
            width: 0
        },
        xaxis: {
            categories: chartData?.categories,
            tickAmount: 8,
            title: {
                style: {
                    fontFamily,
                    colors: AXIS_COLOR,
                    fontSize: '16px'
                }
            },
            labels: {
                style: {
                    colors: AXIS_COLOR,
                    fontSize: '16px'
                }
            },
            axisBorder: {
                show: true,
                color: AXIS_COLOR
            },
            axisTicks: {
                show: true,
                color: AXIS_COLOR
            }
        },
        yaxis: {
            min: 0,
            max: chartData.maxMinutesPerHour,
            title: {
                text: 'Minutos/Hora',
                style: {
                    fontFamily,
                    color: AXIS_COLOR,
                    fontSize: '16px'
                }
            },
            labels: {
                style: {
                    colors: AXIS_COLOR,
                    fontSize: '16px'
                }
            }
        },
        legend: {
            show: showToolbar,
            position: 'bottom',
            fontFamily,
            labels: {
                colors: AXIS_COLOR
            }
        },
        dataLabels: {
            enabled: false
        },
        tooltip: {
            theme: 'dark',
            shared: true,
            intersect: false,
            style: {
                fontFamily
            },
            y: {
                formatter: (val) => `${val} min`
            }
        },
        colors: [GREEN, LINE_COLOR]
    };

    const sanitizeSeriesName = (name) =>
        name
            .replace(/\n/g, '') // elimina saltos de línea
            .replace(/['"]/g, '') // elimina comillas
            .trim();

    const chartSeries = chartData.series.map((s) => ({
        ...s,
        type: 'bar',
        name: sanitizeSeriesName(s.name)
    }));

    return (
        <Box>
            {showLabel && (
                <MuiTypography variant="h5" sx={{ fontWeight: 400, textAlign: 'center', color: 'gray' }}>
                    Tiempo de utilización por hora (minutos).
                </MuiTypography>
            )}
            <Chart options={options} series={chartSeries} height={height} type={'bar'} />
        </Box>
    );
};

export default DowntimeStackedChart;
